import { GetDoc, GetState } from "@/Utils/StateLib";
import { enumUIModes } from "@coreapp/constants";

type ChartModeEntity = "filter" | "highlight" | "sidebar";

const PREFIXES: Record<ChartModeEntity, { chartMode: string; planning: string }> = {
  filter: { chartMode: "chart-mode-filter", planning: "planning-filter" },
  highlight: { chartMode: "chart-mode-highlights", planning: "planning-highlights" },
  sidebar: { chartMode: "chart-mode-sidebar", planning: "planning-sidebar" }
};

const getChartModeTestIdPrefix = (entity: ChartModeEntity): string | undefined => {
  const doc = GetDoc();
  const { chartMode, planning } = PREFIXES[entity];
  if (doc?.IsPlanChart?.()) return planning;
  if (!doc?.IsServerChart?.()) return undefined;
  return chartMode;
};

export const chartModeTestId = (entity: ChartModeEntity, suffix: string): string | undefined => {
  const prefix = getChartModeTestIdPrefix(entity);
  return prefix ? `${prefix}-${suffix}` : undefined;
};

export const planningTestId = (entity: ChartModeEntity, suffix: string): string | undefined => {
  const doc = GetDoc();
  if (!doc?.IsPlanChart?.()) return undefined;
  return `${PREFIXES[entity].planning}-${suffix}`;
};

export const editModeTestId = (suffix: string): string | undefined => {
  const doc = GetDoc();
  if (![enumUIModes.edit, "edit"].includes(GetState?.())) return undefined;
  if (!doc?.IsCustomChart?.()) return undefined;
  return `edit-mode-toolbar-${suffix}`;
};
